<template>
  <li
    class="rounded-small first:rounded-t-large last:rounded-b-large bg-surface-container group relative flex cursor-pointer items-center justify-between overflow-hidden py-4 pr-3 pl-6"
  >
    <span class="text-title-medium" v-if="conductedDialog.conductedAt"
      >Dialog {{ useDisplayRelativeDate(conductedDialog.conductedAt) }}</span
    >
    <BaseIcon>chevron_right</BaseIcon>
    <BaseStateLayer />
  </li>
</template>

<script setup lang="ts">
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { useDisplayRelativeDate } from '@/core/composables/use-display-future-date'
  import type { Dialog } from '@/core/models/dialog/dialog'

  interface Props {
    conductedDialog: Dialog
  }

  defineProps<Props>()
</script>
